<template lang="pug">
div
  // error message poper
  notify-bars
  v-snackbar(v-model='pop_error')
    span(v-html='error_message')
    template(v-slot:action='{ attrs }')
      v-btn(color='white' text v-bind='attrs' @click='pop_error = false')
        | Close
  v-snackbar(v-model='pop_progress' :timeout='-1')
    v-progress-linear(v-model='progress' :active='pop_progress' :indeterminate='progress == 0' query)
  // dialogs
  login-dialog(v-model='show_login')
  feedback-dialog(v-model='show_feedback')
  // app-bar
  v-app-bar(app :dark='banner_dark' prominent shrink-on-scroll fade-img-on-scroll extended scroll-threshold='600' :src='banner_src' ref='appbar')
    template(v-slot:img='{ props }')
      v-img(v-bind='props' :gradient='banner_gradient')
    v-app-bar-nav-icon(@click='drawer = !drawer')
    v-toolbar-title
      v-img(:src='logo' contain position='left' :height='logo_height')
    v-spacer
    v-btn(icon @click='toggle_context_sidebar')
      v-icon mdi-dots-vertical
    template(v-slot:extension)
      template(v-if="theme=='es'")
        v-btn-toggle(group dense text)
          v-btn.mr-2(text to='/' replace) {{$t("toc.home")}}
          v-btn.mr-2(v-if='mainset_id' text :to='`/${mainset_id}`') {{$t("toc."+mainset_id)}}
          v-btn.mr-2(v-if='uniname && uniname!==mainset_id' text :to='`/${uniname}`') {{jname[$en('journal_name')]}}
          v-btn(v-if='isadmin' text :to="{name: 'Admin'}")
            span.mr-2 後台
            v-icon mdi-cog-outline
          template(v-if='test')
            v-btn(text :href='`https://udp.4649.tw${current_path}`' target='_blank')
              span.mr-2 UAT
              v-icon mdi-open-in-new
            v-btn-toggle(v-model='test_mode' mandatory group)
              v-btn(icon)
                v-icon mdi-numeric-1-box-multiple-outline
              v-btn(icon)
                v-icon mdi-numeric-2-box-multiple-outline
              v-btn(icon)
                v-icon mdi-numeric-3-box-multiple-outline
      template(v-else)
        v-btn-toggle(group dense text)
          v-btn.mr-2(text to='/') {{$t("toc.home")}}
          v-btn.mr-2(v-if='uniname && uniname !== mainset_id' text :to='`/${uniname}`')
            | {{jname[$en('journal_name')]}}
      v-spacer
      v-btn-toggle(v-model='locale' mandatory group dense text)
        v-btn(text value='zh-TW') 繁
        v-btn(text value='zh-CN') 简
        v-btn(text value='en') EN
  // nav-drawer
  v-navigation-drawer(app v-model='drawer')
    template(v-slot:prepend)
      v-list-item(two-line to='/')
        v-list-item-icon
          v-icon mdi-home
        v-list-item-content
          v-list-item-title.title {{$t("toc."+theme_name_id)}}
          v-list-item-subtitle {{uname}}
    v-divider
    v-list(dense expand)
      v-list-item(v-if="auth_type == 'user'" @click='logout()')
        v-list-item-title {{$t("logout")}}
      v-list-item(v-else @click='login()')
        v-list-item-title {{$t("login")}}
      v-divider
      template(v-for='(tt, i1) in topics')
        template(v-if="tt.childs.length > 0")
          v-subheader(:key='`topic_${i1}`') {{$t(tt.groupKey)}}
          template(v-for='(it, i2) in tt.childs')
            v-list-item(:key='`topic_${i1}_${i2}`' :to='it.to' replace :href='it.href' :target='it.target' @click='it.show_feedback ? show_feedback=true : null')
              v-list-item-title(:class="sub_test(it.title) ? '' : 'nosub'") {{$t("toc."+it.title)}}
</template>
<script>
import {debug} from 'loglevel'
import {safe_limit} from "@/api/util"
import { get_login_by_ip, mainsets, toc_options } from "@/api"
import {getTokens, setTokens, getIdentity} from "@/api/token"
import LoginDialog from "./LoginDialog"
import FeedbackDialog from "./FeedbackDialog"
import NotifyBars from "./NotifyBars"
const dark_banner = ['art', 'waa']
const myStorage = window.localStorage

export default {
  watch: {
    locale(v) {
      debug('locale', v)
      if(['en', 'zh-TW', 'zh-CN'].includes(v)) {
        myStorage.setItem('locale', v)
        this.$i18n.locale = v
        this.$store.commit('set_locale', v)
      }
    },
    test_mode(vv) {
      this.$store.commit('set_test_mode', vv)
    },
    '$store.state.test': {
      handler() {
        debug('watch $store.state.test', this.$store.state.test)
        this.test = this.$store.state.test
      },
      immediate: true,
    },
  },
  mounted() {
    this.$watch(
      "$refs.appbar.computedContentHeight",
      (vv) => {
        this.appbar_content_height = vv
      },
      {immediate: true}
    )
  },
  computed: {
    isadmin() {
      return Boolean(this.allow && this.allow.includes('admin'))
    },
    banner_title_font_style() {
      const [max, min] = [3.8, 1.2]
      const ratio = (max-min) / (176-56)
      const height = (this.appbar_content_height - 56) * ratio + min
      return `font-size: ${safe_limit(height, min, max)}rem;`
    },
    logo_height() {
      const [max, min] = [96, 36]
      const ratio = (max-min) / (176-56)
      const height = (this.appbar_content_height - 56) * ratio + min
      return safe_limit(height, min, max)
    },
    banner() {
      return mainsets.includes(this.mainset_id) ? this.mainset_id : 'es'
    },
    banner_dark() {
      if(dark_banner.includes(this.banner)) {
        return true
      }
      else {
        return undefined
      }
    },
    logo() {
      return `/images/${this.banner}/logo.png`
    },
    banner_src() {
        return `/images/${this.banner}/banner_bg.jpg`
    },
    banner_gradient() {
      return undefined
    },
    topics() {
      const topics_ = [
        {
          groupKey: this.theme=='es' ? "toc.es" : "toc." + this.theme_name_id,
          icon: "mdi-home",
          // color: "blue",
          childs: [
            {title: "home", to: "/"}
          ]
        },
        {
          groupKey: "toc.arts",
          icon: "mdi-image-album",
          // color: "purple",
          childs: [],
        },
        {
          groupKey: "toc.journal",
          icon: "mdi-book-open-variant",
          color: "purple",
          childs: [],
        },
        {
          groupKey: "toc.book",
          icon: "mdi-bookshelf",
          // color: "",
          childs: [],
        },
        {
          groupKey: "toc.nosub",
          icon: "mdi-bookshelf",
          childs: [],
        },
        {
          groupKey: "toc.about",
          icon: "mdi-information",
          // color: "grey",
          childs: [
            {title: "usage", to: {name: 'AboutUsage'}},
            {
              title: "feedback",
              show_feedback: true,
            },
            {title: "tos", to: {name: 'AboutTerms'}},
            {title: "udp", href:"https://www.udpweb.com/about/", target:"_blank"},
          ]
        },
      ]
      for(let i = 0; i < toc_options.length; i++) {
        let v = toc_options[i]
        let [setsn, _] = v.id.split('_', 2)
        if(setsn == 'group') {
          continue
        }
        if(!this.sub_test(setsn)) {
          topics_[4].childs.push({
            title: setsn,
            to: `/${setsn}`,
          })
        }
        else if(['tdm', 'tcm', 'soc', 'sin', 'bio', 'mdn'].includes(setsn)) {
          topics_[2].childs.push({
            title: setsn,
            to: `/${setsn}`,
          })
        }
        else if(['npm', 'art', 'waa'].includes(setsn)) {
          topics_[1].childs.push({
            title: setsn,
            to: `/${setsn}`,
          })
        }
        else if(['cbs', 'tai', 'syu'].includes(setsn)) {
          topics_[3].childs.push({
            title: setsn,
            to: `/${setsn}`,
          })
        }
      }
      const r_topics = this.theme == 'es' ? topics_.slice(1) : [topics_[0], topics_[4]]
      debug('theme', this.theme, this.theme_name_id, topics_)
      return r_topics
    },
  },
  created() {
    this.$store.subscribe((mutation) => {
      if (mutation.type == "login") {
        this.login()
      }
      else if (mutation.type == "logout") {
        this.logout()
      }
      else if (mutation.type == "hide_app_drawer") {
        this.drawer = false
      }
      else if (mutation.type == "error") {
          this.error_message = mutation.payload;
        this.pop_error = true;
      }
      else if (mutation.type == "set_login") {
        const {uname, auth_type, allow, allow_uniname} = mutation.payload
        this.uname = uname
        this.auth_type = auth_type
        this.allow = allow
        this.allow_uniname = allow_uniname
      }
      else if (mutation.type == 'set_mainset') {
        this.uniname = this.journal_name = this.journal_en_name = undefined
        this.mainset_id = this.$store.state.mainset_id
        this.mainset_name = this.$store.state.mainset_name
        window.document.title = this.$store.state.mainset_name
      }
      else if (mutation.type == 'set_uniname') {
        this.uniname = this.$store.state.uniname
        this.journal_name = this.$store.state.journal_name
        this.journal_en_name = this.$store.state.journal_en_name
        this.jname = {
          journal_name: this.$store.state.journal_name,
          journal_en_name: this.$store.state.journal_en_name
        }
        this.mainset_id = this.$store.state.mainset_id
        this.mainset_name = this.$store.state.mainset_name
        window.document.title = this.$store.state.mainset_name
      }
      else if (mutation.type == 'to_path') {
        // const {path, query} = mutation.payload
        this.current_path = this.$store.state.current_path
      }
      else if (mutation.type == 'set_query') {
        this.current_query = mutation.payload
      }
      else if (mutation.type == 'set_progress') {
        const {progress, show}= mutation.payload
        this.pop_progress = show
        this.progress = progress
      }
    });
  },
  methods: {
    toggle_context_sidebar() {
      this.$store.commit("toggle_context_sidebar")
    },
    logout() {
      setTokens({})
      get_login_by_ip()
    },
    login() {
      this.show_login = !this.show_login
    },
    sub_test(setsn) {
      if(!mainsets.includes(setsn)) {
        return true
      }
      if(this.allow == undefined) {
        return false
      }
      if(!this.allow.includes('view_artis')) {
        return false
      }
      // debug('sub_test', setsn, this.allow, this.allow_uniname)
      if(this.allow_uniname == undefined) {
        return true
      }
      if(this.allow_uniname.includes(setsn)) {
        return true
      }
      return false
    },
  },
  data() {
    // debug('nav', this.mainset_id, this.uniname)
    const {uname, auth_type, allow, allow_uniname} = getIdentity()
    debug('getIdentity', {uname, auth_type, allow, allow_uniname})
    // this.$store.commit('set_login', {uname, auth_type, isadmin, allow, allow_uniname})
    const theme = this.$store.state.theme  // es 全庫, p 單庫
    const theme_name = this.$store.state.theme_name
    const mainset_id = this.$store.state.mainset_id
    const theme_name_id = theme == 'es' ? 'es' : mainset_id
    let locale = myStorage.getItem('locale')
    if(!['en', 'zh-TW', 'zh-CN'].includes(locale)) {
      locale = 'zh-TW'
    }
    this.$i18n.locale = locale
    const jinfo = require("@/../sdata/jinfo.json")
    // debug('jinfo', jinfo)
    return {
      theme,
      theme_name_id,
      theme_name,
      mainset_id,
      mainset_name: this.$store.state.mainset_name,
      uniname: this.$store.state.uniname,
      journal_name: this.$store.state.journal_name,
      journal_en_name: this.$store.state.journal_en_name,
      jname: {
        journal_name: this.$store.state.journal_name,
        journal_en_name: this.$store.state.journal_en_name,
      },
      drawer: true,
      pop_error: false,
      error_message: null,
      current_path: this.$store.state.current_path,
      current_query: this.$store.state.current_query,

      pop_progress: false,
      progress: 0,  // 0-100

      uname,
      auth_type,
      allow,
      allow_uniname,
      access_token: undefined,
      show_login: false,
      show_feedback: false,

      appbar_content_height: 176,
      test: false,
      test_mode: 0,

      locale,
      jinfo,
    }
  },
  setup(props) {
    return {

    }
  },
  props: {
    encoded_pwd: {},
  },
  components: {
    LoginDialog,
    FeedbackDialog,
    NotifyBars,
  }
}
</script>
<style scoped>
.theme--light.v-subheader {color: rgba(0, 0, 255, 0.6)}
.nosub { color: lightgray; }
</style>
